import { parseMatchingUrl } from '../../../../services/api/matchingSessions';
import type { MatchingTransport } from './types';

/** The real transport: a browser WebSocket to matching-server. */
export const wsTransport: MatchingTransport = {
  open(matchingUrl, handlers) {
    const { wsUrl } = parseMatchingUrl(matchingUrl);
    const ws = new WebSocket(wsUrl);
    let closedByUs = false;

    ws.onopen = () => handlers.onOpen();
    ws.onmessage = event => {
      try {
        handlers.onMessage(JSON.parse(String(event.data)));
      } catch {
        // A message we can't parse can't change state; skip it.
      }
    };
    ws.onclose = event => {
      if (!closedByUs)
        handlers.onClose({ code: event.code, reason: event.reason });
    };

    return {
      send(msg) {
        if (ws.readyState !== WebSocket.OPEN) return false;
        ws.send(JSON.stringify(msg));
        return true;
      },
      close() {
        closedByUs = true;
        ws.close();
      },
    };
  },
};
